export default {"src":"/_next/static/media/whatsapp.78de619a.svg","height":16,"width":16};